import * as React from "react";
import {Component } from "react";

import {observer} from "mobx-react";
import _ from "lodash";
import {Item, Message, Placeholder, Table} from "semantic-ui-react";
import {Auftragsverwaltung} from "../../stores/auftragsverwaltung-mobx";
import {Project} from "../../models/project";
import {ProcessSource} from "../../models/process-source";

export interface ProcessSourceListProps {
    auftragsverwaltung: Auftragsverwaltung;
    project: Project;
    title?: string;
}
interface SortAction {
    type: string;
    column: string;
}
@observer
export class ProcessSourceList extends Component<ProcessSourceListProps, any> {
    watchHandles: any[] = [];
    constructor(props: ProcessSourceListProps) {
        super(props);
        this.state = {
            isLoading: true,
            error: null,
            column: null,
            data: null,
            direction: null
        };
        this.sort = this.sort.bind(this);
    }
    sort(action: SortAction): void {
        switch (action.type) {
        case "CHANGE_SORT":
            if (this.state.column === action.column) {
                this.setState((state: any) =>({
                    data: state.data.reverse(),
                    direction: state.direction === "ascending" ? "descending" : "ascending"
                }));
            } else {
                this.setState((state: any) =>({
                    column: action.column,
                    data: _.sortBy(state.data, [action.column], ["asc"]),
                    direction: "ascending",
                }));
            }
            return;
        default:
            throw new Error();
        }
    }

    componentDidMount(): void {
        const { project, auftragsverwaltung} = this.props;

        if (!project || !project.id) {
            return;
        }

        auftragsverwaltung.ProcessSourceStore.loadItems(project.id).then((processSources: ProcessSource[]) => {
            const data = _.orderBy(processSources, ["name"], ["asc"]);
            this.setState({
                data,
                column: "name",
                direction: "ascending",
                isLoading: false
            });
        }).catch((error) => {
            this.setState({
                error
            });
        });
    }
    componentWillUnmount(): void {
        this.watchHandles.forEach((handle: any) => {
            handle.remove();
        });
        this.watchHandles.length = 0;
    }
    render(): React.ReactElement | null {
        const { column, data, direction, isLoading, error } = this.state;

        if (isLoading) {
            return (
                <div>
                    <h3 id="react-arcgis-loading-text">Prozessquellen laden...</h3>
                    <Placeholder>
                        <Placeholder.Header>
                            <Placeholder.Line />
                        </Placeholder.Header>
                    </Placeholder>
                </div>
            );
        }

        if(error) {
            return (
                <Message negative>
                    <Message.Header>Fehler beim Laden der Prozessquellen</Message.Header>
                    {error}
                </Message>
            );
        }

        if (data.length === 0) {
            return (
                <Item><Item.Content>
                    <Message
                        info
                        size="mini"
                        header='Aufbereitung Prozessquellen'
                        content="Die Prozessquellen werden bei der Datenaufbereitung aufgrund des Perimeters und
                        der Teilaufträge bestimmt und danach hier angezeigt."
                    />
                </Item.Content></Item>);
        }
        return (
            <Item><Item.Content>
                {/* <Item.Header as="h3">{title}</Item.Header>*/}
                <Table basic="very" sortable={(data.length > 1)} compact className={"process-sources"}>
                    <Table.Header>
                        <Table.Row>
                            <Table.HeaderCell width={1} singleLine
                                sorted={column === "objectId" ? direction : null}
                                onClick={() => this.sort({ type: "CHANGE_SORT", column: "objectId" })}>
                                ID
                            </Table.HeaderCell>
                            <Table.HeaderCell sorted={column === "name" ? direction : null}
                                onClick={() => this.sort({ type: "CHANGE_SORT", column: "name" })}>
                                Name
                            </Table.HeaderCell>
                            <Table.HeaderCell colSpan={2} sorted={column === "code" ? direction : null}
                                onClick={() => this.sort({ type: "CHANGE_SORT", column: "code" })}>
                                Prozessquellennummer
                            </Table.HeaderCell>
                        </Table.Row>
                    </Table.Header>
                    <Table.Body>
                        {data.map(({ objectId, name, code }: ProcessSource) => (
                            <Table.Row key={objectId}>
                                <Table.Cell singleLine>{objectId}</Table.Cell>
                                <Table.Cell>{name}</Table.Cell>
                                <Table.Cell singleLine className={"code"}>{code}</Table.Cell>
                            </Table.Row>
                        ))}
                    </Table.Body></Table>
            </Item.Content></Item>
        );
    }
}
